import { render } from "./LeaveGroupConfirm.vue?vue&type=template&id=2747e32b&scoped=true"
import script from "./LeaveGroupConfirm.vue?vue&type=script&lang=js"
export * from "./LeaveGroupConfirm.vue?vue&type=script&lang=js"

import "./LeaveGroupConfirm.vue?vue&type=style&index=0&id=2747e32b&lang=scss&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2747e32b"]])

export default __exports__